import { useEffect, useState } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { FAST_ANIMATION_DURATION } from 'src/lib/player/constants';
import { t } from 'src/lib/player/i18n';
import { easeInOut } from 'src/lib/player/utils';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';

export default function NavigationControl(): JSX.Element {
  const map = useMap();

  const [bearing, setBearing] = useState(0);
  const [pitch, setPitch] = useState(0);

  useEffect(() => {
    if (map.current != null) {
      setBearing(map.current.getBearing());
      setPitch(map.current.getPitch());
    }

    const setter = () => {
      if (map.current != null) {
        setBearing(map.current.getBearing());
        setPitch(map.current.getPitch());
      }
    };
    map.current?.on('move', setter);
    return () => {
      map.current?.off('move', setter);
    };
  }, []);

  const compassTransform = `scale(${1 / Math.sqrt(Math.cos(pitch * (Math.PI / 180)))}) rotateX(${pitch}deg) rotateZ(${bearing}deg)`;

  return (
    <div className="mapboxgl-ctrl mapboxgl-ctrl-group">
      <button
        className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in"
        title={t('Zoom in')}
        {...onClickGenerator(() => {
          map.current?.zoomIn({ duration: FAST_ANIMATION_DURATION, easing: easeInOut });
        })}
      >
        <span className="mapboxgl-ctrl-zoom-in-icon" aria-hidden="true" />
      </button>
      <button
        className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out"
        title={t('Zoom out')}
        {...onClickGenerator(() => {
          map.current?.zoomOut({ duration: FAST_ANIMATION_DURATION, easing: easeInOut });
        })}
      >
        <span className="mapboxgl-ctrl-zoom-out-icon" aria-hidden="true" />
      </button>
      <button
        className="mapboxgl-ctrl-icon mapboxgl-ctrl-compass"
        title={t('Reset bearing to north')}
        {...onClickGenerator(() => {
          map.current?.resetNorthPitch({ duration: FAST_ANIMATION_DURATION, easing: easeInOut });
        })}
      >
        <span className="mapboxgl-ctrl-compass-arrow" style={{ transform: compassTransform }} />
      </button>
    </div>
  );
}
